import React from 'react'
import {Route, IndexRoute} from 'react-router'

import App from './index'
import Home from '../home'
//import Invite from '../invite'

//import UpStartWorks from '../content/upstartworks'
//import UncommonGames from '../content/uncommongames'
//import UncommonCharity from '../content/uncommoncharity'
//import IdeaFounder from '../content/ideafounder'
import NotFound from '../error/not_found'

const routes = (
  <Route>
    <Route path="/" component={App}>
      <IndexRoute component={Home} />
      <Route path="*" component={NotFound} />
    </Route>
  </Route>
)

export default routes



// WEBPACK FOOTER //
// ./src/app/routes.js